import { Drawer, Box, Typography, Grid } from '@mui/material'
import { X } from 'lucide-react'
import React from 'react'
import { Button } from '../ui/button';

interface CustomDrawerProps {
    onClose: () => void;
    title: string;
    children: React.ReactNode;
    onSubmit: (data: any) => void;
    handleSubmit: (onValid: (data: any) => void) => (e: React.BaseSyntheticEvent) => void;
}

const CustomDrawer: React.FC<CustomDrawerProps> = ({
    handleSubmit,
    onSubmit,
    onClose,
    title,
    children
}) => {
    return (
        <Drawer
            anchor="right"
            open={true}
            onClose={onClose}
            sx={{
                '& .MuiDrawer-paper': { width: { xs: '100%', sm: 400 } },
            }}
        >
            <form
                onSubmit={handleSubmit(onSubmit)}
                style={{ height: "100%", display: "flex", flexDirection: "column" }}
            >
                {/* Header */}
                <Box
                    sx={{
                        p: 2,
                        display: "flex",
                        justifyContent: "space-between",
                        alignItems: "center",
                        borderBottom: "1px solid #eee",
                    }}
                >
                    <Typography variant="h6">{title}</Typography>
                    <X className="cursor-pointer" onClick={onClose} />
                </Box>

                {/* Content */}
                <Box sx={{ flex: 1, overflowY: "auto", p: 2 }}>
                    {children}
                </Box>

                {/* Footer (sticks to bottom) */}
                <Box
                    sx={{
                        p: 2,
                        borderTop: "1px solid #eee",
                        display: "flex",
                        justifyContent: "flex-end",
                        gap: 1,
                        width: "100%",
                    }}
                >
                    <Grid container spacing={2} sx={{width: "100%"}}>
                        <Grid size={{ xs: 12, md : 6 }}>
                            <Button type="button" variant="error" color="error" onClick={onClose}>
                                Cancel
                            </Button>
                        </Grid>
                        <Grid size={{ xs: 12, md : 6 }} sx={{display: "flex", justifyContent: { xs: "flex-start", md: "flex-end" }}}>
                            <Button type="submit" variant="default">
                                Submit
                            </Button>
                        </Grid>
                    </Grid>
                </Box>
            </form>
        </Drawer>
    )
}

export default CustomDrawer
